/* @flow */
import UserAgent from "nx-components/UserAgent";
import BasePlatform from "nexia_mobile/platforms/base";
import AndroidPlatform from "nexia_mobile/platforms/android";
import IOSPlatform from "nexia_mobile/platforms/ios";
import Win10Platform from "nexia_mobile/platforms/win10";
import QueryParams from "nx-components/QueryParams";

const singleton = (() => {
  if (UserAgent.isWindows10WebView()) {
    return new Win10Platform();
  }

  const platform = QueryParams.platform();
  if (platform === "ios-wkwebview" || platform === "ios-uiwebview") {
    return new IOSPlatform();
  }
  if (platform === "android") {
    return new AndroidPlatform();
  }

  return new BasePlatform();
})();

// So that native code can do eg. `PlatformInterface.triggerAppPause()`.
// It has to be global because native code just executes a string.
window.PlatformInterface = singleton;
export default singleton;



// WEBPACK FOOTER //
// ./src/platform.js